import React from 'react'
import '../HomeStyle/Hero.css'
import HeroImg from '../Assets/hero.jpg'

const HeroSection = () => {
  return (
    <section className='hero'>
      <div>
        <span className='hero_badge'>Industry-aligned education</span>
        <h1 className='heroSection_heading'>
          Breaking barriers and <em>transforming</em> the learning experience
        </h1>
        <p className='heroSection_para'>
          Bridging the gap between education and industry, empowering students with the skills they need to succeed in the modern workforce.
        </p>

        <div className='heroSection_btnContainer'>
          <a
            href="https://makes.mindmatrix.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="heroSection_btn primary_btn"
          >
            Learn More
          </a>
          <a
            href="https://lms.mindmatrix.io/login"
            target="_blank"
            rel="noopener noreferrer"
            className="heroSection_btn secondary_btn"
          >
            Register
          </a>
        </div>
      </div>

      <div className='hero_visual' style={{ backgroundImage: `url(${HeroImg})` }}>
        <div className='hero_chip'>
          <strong>Work-ready graduates</strong>
          Curriculum built with industry, delivered on campus and online.
        </div>
      </div>
    </section>
  )
}

export default HeroSection
